<ada-container
	data-testid="memory-pipeline-view-container"
	[height]="'100%'"
>
	<ada-drawer
		contentPadding="0px"
		data-testid="memory-pipeline-view-drawer"
		drawerPosition="right"
		[drawerTitle]="'Memory Pipeline'"
		[expandedSize]="500"
		[height]="'100%'"
		[triggerIconColor]="'primary'"
	>
		<ada-container
			data-container-selector="ada-drawer-drawerContent"
			horizontalSpacing="small"
			verticalSpacing="medium"
			[colCount]="4"
		>
			<ada-label
				content="Adaptiva Content Memory Pipeline"
				fontWeight="bold"
				textColor="primary"
				[responsiveConfiguration]="ui.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
			/>
			<ada-text
				content="Fault-tolerant P2P content delivery system ensures rapid and secure content distribution across the network. The memory pipeline architecture automatically reconfigures in real time, regardless of device status or connection, to ensure uninterrupted delivery of content."
				[responsiveConfiguration]="ui.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
			/>

			<ada-label
				content="Content Selection"
				fontWeight="bold"
				textColor="primary"
				[responsiveConfiguration]="ui.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
			/>
			<ada-object-list
				#ContentList
				data-testid="memory-pipleine-page-content-list"
				id="ContentList"
				[isMultiselect]="false"
				[javaClassName]="packageClassName"
				[responsiveConfiguration]="ui.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
				[staticFilterCondition]="publishedFilter"
				(objectIdsChange)="contentId.next($event)"
			/>

			@if (activeSelection | async; as _selection) {
				<ada-container
					data-container-selector="ada-drawer-drawerContent"
					[colCount]="2"
					[colSpan]="4"
				>
					<ada-label
						content="Host Name"
						textColor="primary"
						[responsiveConfiguration]="selectionDrawerResponsiveConfig"
					/>
					<ada-text
						[content]="_selection.hostName"
						[responsiveConfiguration]="selectionDrawerResponsiveConfig"
					/>
					<ada-label
						content="Ip Address"
						textColor="primary"
						[responsiveConfiguration]="selectionDrawerResponsiveConfig"
					/>
					<ada-text
						[content]="_selection.ipAddress"
						[responsiveConfiguration]="selectionDrawerResponsiveConfig"
					/>
					<ada-label
						content="Source Host Name"
						textColor="primary"
						[responsiveConfiguration]="selectionDrawerResponsiveConfig"
					/>
					<ada-text
						[content]="_selection.sourceHostName || '--'"
						[responsiveConfiguration]="selectionDrawerResponsiveConfig"
					/>
					<ada-label
						content="Source Ip Address"
						textColor="primary"
						[responsiveConfiguration]="selectionDrawerResponsiveConfig"
					/>
					<ada-text
						[content]="_selection.sourceIpAddress || '--'"
						[responsiveConfiguration]="selectionDrawerResponsiveConfig"
					/>
					<ada-label
						content="Transfer Type"
						textColor="primary"
						[responsiveConfiguration]="selectionDrawerResponsiveConfig"
					/>
					<ada-text
						[content]="_selection.transferType"
						[responsiveConfiguration]="selectionDrawerResponsiveConfig"
					/>
					<ada-label
						content="Operating System"
						textColor="primary"
						[responsiveConfiguration]="selectionDrawerResponsiveConfig"
					/>
					<ada-text
						[content]="displayOsValue(_selection.operatingSystem)"
						[responsiveConfiguration]="selectionDrawerResponsiveConfig"
					/>
					<ada-label
						content="Bytes Downloaded"
						textColor="primary"
						[responsiveConfiguration]="selectionDrawerResponsiveConfig"
					/>
					<ada-text
						content="{{ _selection.bytesDownloaded | adaBytesToSize }} / {{ _selection.totalBytes | adaBytesToSize }}"
						[responsiveConfiguration]="selectionDrawerResponsiveConfig"
					/>
					<ada-label
						content="Percent Complete"
						textColor="primary"
						[responsiveConfiguration]="selectionDrawerResponsiveConfig"
					/>
					<ada-text
						[content]="_selection.percentComplete"
						[responsiveConfiguration]="selectionDrawerResponsiveConfig"
					/>
					<ada-label
						content="Clients"
						textColor="primary"
						[colSpan]="2"
					/>
					@for (client of _selection.clients; track client.hostName) {
						<ada-text
							[colSpan]="2"
							[content]="client.hostName"
						/>
					}
				</ada-container>
			}
		</ada-container>
		<div
			class="ada-display-block ada-full-size ada-overflow-hidden"
			data-container-selector="ada-drawer-mainContent"
		>
			@if (rootContentMemoryNodes) {
				<ada-memory-pipeline
					#MemoryPipeline
					class="ada-display-block ada-full-size ada-overflow-hidden"
					[rootNodes]="rootContentMemoryNodes"
					[style.position]="'relative'"
					(activeSelectionChange)="activeSelection.next($event)"
				/>
			}
		</div>
	</ada-drawer>
</ada-container>
